export default __webpack_public_path__ + "static/media/icon-info-white.21869ed8.svg";